/* eslint-disable no-unused-vars */
import styled, { css } from 'styled-components';
import { Palette } from 'config';

export const RadioWrap = styled.div`
  position: relative;
  width: 20px;
  height: 20px;

  input {
    cursor: pointer;
  }

  input:checked + div {
    border: 6px solid ${Palette.Primary._500};
  }

  input:checked + div:hover {
    border: 6px solid ${Palette.Primary._600};
  }
`;

export const Radio = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  border-radius: 50%;
  border: 2px solid ${Palette.PrimaryGray._400};
  background-color: ${Palette.PrimaryGray._000};
  display: inline-block;
  pointer-events: none;

  &:hover {
    border: 2px solid ${Palette.Primary._600};
  }

  ${({ disabled }) =>
    disabled &&
    `
     opacity: 0.5;
     cursor: not-allowed;
   `}
`;
